$(document).ready(function(){
  
  var $parent = $("#shuffle");
  var $divs = $parent.children();

  setInterval(function() {
    var $clone = $divs.slice();
    while ($clone.length) {
      $parent.append($clone.splice(Math.floor(Math.random() * $clone.length), 1));
    }
  }, 2000);
 
$(".logo-container img").attr("src","https://cdn.shopify.com/s/files/1/0452/7033/5645/t/2/assets/logo.svg?v=1606725177");
$(".logo-footer img").attr("data-src","https://cdn.shopify.com/s/files/1/0452/7033/5645/t/2/assets/logo.svg?v=1606725177");  
$.get("https://ipinfo.io", function(response) {

  //  if(response.country == "IN") {
  // 	 $("body").prepend("<marquee loop behavior='scroll' direction='left' id='free_shipping'>FREE SHIPPING ALL ACROSS INDIA FOR ORDERS OVER RS.499&nbsp;&nbsp; | &nbsp;&nbsp;<a href='/pages/faqs' style='opacity:1 !important;'> MORE INFO HERE</a>&nbsp;&nbsp; • &nbsp;&nbsp; INTERNATIONAL SHIPPING TO ALL MAJOR COUNTRIES GLOBALLY &nbsp;&nbsp; • &nbsp;&nbsp; COD AVAILABLE FOR ALL ORDERS ACROSS INDIA &nbsp;&nbsp; • &nbsp;&nbsp; HASSLE FREE EXCHANGES AND RETURNS&nbsp;&nbsp; • &nbsp;&nbsp; NEW DESIGNS ADDED EVERY MONTH</marquee>");
  // }
   
  if(response.country == "IN") {
  	 $("body").prepend("<marquee  loop behavior='scroll' direction='left' id='free_shipping'>FREE SHIPPING ALL ACROSS INDIA FOR ORDERS OVER RS.399&nbsp;&nbsp; | &nbsp;&nbsp;<a href='/pages/faqs' style='opacity:1 !important;'> MORE INFO HERE</a>&nbsp;&nbsp; • &nbsp;&nbsp; INTERNATIONAL SHIPPING TO ALL MAJOR COUNTRIES GLOBALLY &nbsp;&nbsp; • &nbsp;&nbsp; COD AVAILABLE FOR ALL ORDERS ACROSS INDIA &nbsp;&nbsp; • &nbsp;&nbsp; HASSLE FREE EXCHANGES AND RETURNS&nbsp;&nbsp; • &nbsp;&nbsp; NEW DESIGNS ADDED EVERY MONTH</marquee>");
  }
  
}, "jsonp");
  
  
  $('body').on('click','#cart',function(e){
  	e.preventDefault();
    window.location.replace("/cart");
  
  })

});